// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { listTreeDatabase16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-list-tree-database': IconListTreeDatabase;
    }
}

/**
 * The icon component for the 'listTreeDatabase' icon
 */
export class IconListTreeDatabase extends Icon {
    public constructor() {
        super(listTreeDatabase16X16);
    }
}

registerIcon('icon-list-tree-database', IconListTreeDatabase);
export const iconListTreeDatabaseTag = 'nimble-icon-list-tree-database';
